/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnalyticsInsightCtaDto } from './analytics-insight-cta-dto';
import { AnalyticsInsightDtoParamsValue } from './analytics-insight-dto-params-value';


export interface AnalyticsInsightDto { 
    key: AnalyticsInsightDto.KeyEnum;
    /**
     * Severity assigned by fixed rules, not statistical confidence or a prediction.
     */
    status: AnalyticsInsightDto.StatusEnum;
    /**
     * Values for rendering the rule: rate is a fraction; change is an absolute fraction difference (0.05 = 5 percentage points), not relative percent change.
     */
    params: { [key: string]: AnalyticsInsightDtoParamsValue; };
    cta: AnalyticsInsightCtaDto;
}
export namespace AnalyticsInsightDto {
    export const KeyEnum = {
        RedemptionRateLow: 'redemption_rate_low',
        RedemptionRateHigh: 'redemption_rate_high',
        ReferralShareChange: 'referral_share_change',
        UninstallSpike: 'uninstall_spike',
        ConversionDrop: 'conversion_drop'
    } as const;
    export type KeyEnum = typeof KeyEnum[keyof typeof KeyEnum];
    export const StatusEnum = {
        Good: 'good',
        Warning: 'warning',
        Serious: 'serious'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


